/* jshint esversion: 6 */
/* jshint esversion: 11 */
/* jshint ignore:start */
import { createContext, useEffect, useRef, useState } from 'react';
import axios from 'axios';
import secureLocalStorage from 'react-secure-storage';

const MyContext = createContext();

const DEFAULT_SETTINGS = {
    title: "RapidMediK",
    support_email: "care@rapidmedik.in",
    support_phone: "",
    site_currency: "₹",
    light_image: "",
};

const MyProvider = ({ children }) => {

    const ApiBaseUrl = process.env.REACT_APP_API_BASE_URL || "https://portal.rapidmedik.com";
    const ImgBaseUrl = process.env.REACT_APP_IMG_BASE_URL || `${ApiBaseUrl}/`;

    const [isLoginShow, setIsLoginShow] = useState(false);
    const [isSignUpShow, setIsSignUpShow] = useState(false);
    const [isLogin, setIsLogin] = useState("");
    const [isPayment, setIsPayment] = useState(false);
    const [paymentStatus, setPaymentStatus] = useState("");
    const [patientStatus, setPatientStatus] = useState("");
    const [isShow, setIsShow] = useState(false);
    const [showBox, setshowBox] = useState(false);
    const [isFooter, setIsFooter] = useState(false);
    const [showMenu, setShowMenu] = useState(false);
    const [activePage, setActivePage] = useState("");
    const [agoraAppId, setAgoraAppId] = useState("");
    const [showCall, setShowCall] = useState(false);
    const [mapKey, setMapKey] = useState("");
    const [transactionid, setTransactionId] = useState("");
    const [apiloading, setApiLoading] = useState(false);
    const [selectproduct, setSelectProduct] = useState("");
    const [siteLogo, setSiteLogo] = useState("");
    const [siteTitle, setSiteTitle] = useState(DEFAULT_SETTINGS.title);
    const [supportEmail, setSupportEmail] = useState(DEFAULT_SETTINGS.support_email);
    const [supportPhone, setSupportPhone] = useState(DEFAULT_SETTINGS.support_phone);
    const [siteCurrency, setSiteCurrency] = useState(DEFAULT_SETTINGS.site_currency);

    const MenuRef = useRef();

    const applyGeneralSettings = (settings = {}) => {
        if (!settings || typeof settings !== "object") return;

        if (settings.site_currency) {
            secureLocalStorage.setItem("currency", settings.site_currency);
            setSiteCurrency(settings.site_currency);
        }
        if (settings.light_image) {
            secureLocalStorage.setItem("site_logo", settings.light_image);
            setSiteLogo(settings.light_image);
        }
        if (settings.title) {
            secureLocalStorage.setItem("site_title", settings.title);
            setSiteTitle(settings.title);
        }
        if (settings.support_email) {
            secureLocalStorage.setItem("support_email", settings.support_email);
            setSupportEmail(settings.support_email);
        }
        if (settings.support_phone) {
            secureLocalStorage.setItem("support_phone", settings.support_phone);
            setSupportPhone(settings.support_phone);
        }
        if (settings.agora_app_id) setAgoraAppId(settings.agora_app_id);
        if (settings.google_map_key) setMapKey(settings.google_map_key);
        if (settings.one_app_id_react) {
            secureLocalStorage.setItem("one_app_id_react", settings.one_app_id_react);
        }

        secureLocalStorage.setItem("general_settings", JSON.stringify({
            title: settings.title || DEFAULT_SETTINGS.title,
            support_email: settings.support_email || DEFAULT_SETTINGS.support_email,
            support_phone: settings.support_phone || "",
            site_currency: settings.site_currency || DEFAULT_SETTINGS.site_currency,
            light_image: settings.light_image || "",
        }));
    };

    useEffect(() => {
        if (activePage) {
            sessionStorage.setItem("activepage", activePage);
        }
    }, [activePage]);

    useEffect(() => {
        try {
            const cached = secureLocalStorage.getItem("general_settings");
            if (cached) {
                const parsed = typeof cached === "string" ? JSON.parse(cached) : cached;
                applyGeneralSettings(parsed);
            } else {
                const logo = secureLocalStorage.getItem("site_logo");
                const title = secureLocalStorage.getItem("site_title");
                const email = secureLocalStorage.getItem("support_email");
                const phone = secureLocalStorage.getItem("support_phone");
                const currency = secureLocalStorage.getItem("currency");
                if (logo) setSiteLogo(logo);
                if (title) setSiteTitle(title);
                if (email) setSupportEmail(email);
                if (phone) setSupportPhone(phone);
                if (currency) setSiteCurrency(currency);
            }
        } catch (error) {
            console.error("Failed to hydrate general settings", error);
        }

        axios.get(`${ApiBaseUrl}/customer/general_settings`)
            .then((res) => {
                if (res.data?.ResponseCode === 200 && res.data?.general_currency) {
                    applyGeneralSettings(res.data.general_currency);
                }
            })
            .catch((error) => {
                console.error("general_settings", error);
            });
    }, [ApiBaseUrl]);

    const Value = {
        isLoginShow, setIsLoginShow,
        isSignUpShow, setIsSignUpShow,
        isLogin, setIsLogin,
        isPayment, setIsPayment,
        paymentStatus, setPaymentStatus,
        patientStatus, setPatientStatus,
        isShow, setIsShow,
        showBox, setshowBox,
        isFooter, setIsFooter,
        showMenu, setShowMenu,
        activePage, setActivePage,
        agoraAppId, setAgoraAppId,
        showCall, setShowCall,
        mapKey, setMapKey,
        transactionid, setTransactionId,
        apiloading, setApiLoading,
        selectproduct, setSelectProduct,
        siteLogo, setSiteLogo,
        siteTitle, setSiteTitle,
        supportEmail, setSupportEmail,
        supportPhone, setSupportPhone,
        siteCurrency, setSiteCurrency,
        applyGeneralSettings,
        ApiBaseUrl, ImgBaseUrl,
        MenuRef
    };

    return (
        <MyContext.Provider value={Value}>
            {children}
        </MyContext.Provider>
    );
};

export { MyContext, MyProvider };
/* jshint ignore:end */
